import { useContext } from 'react';
import { CustomerDetailsContext } from '../../providers/CustomerDetailsProvider';

export default function useCustomerDetails() {
  return useContext(CustomerDetailsContext);
}
